import Button, { ButtonProps } from '@codegouvfr/react-dsfr/Button';
import { PropsWithChildren } from 'react';
import '../buttons.css';

interface DangerButtonProps extends PropsWithChildren {
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
  type?: ButtonProps["type"];
}

export const DangerButton = ({ disabled, onClick, className, type, children }: DangerButtonProps) => {
  return <Button
    priority={'secondary'}
    disabled={disabled ?? false}
    className={`fc-button--red ${className ?? ''}`}
    type={type}
    onClick={() => onClick?.()}
  >
    {children}
  </Button>;
};